import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Añade esta importación

const firebaseConfig = {
  apiKey: "AIzaSyBofn-_O-Gd4mV7Kdgg1hfDuVUoh3Gi5Ak",
  authDomain: "arzu-9380c.firebaseapp.com",
  projectId: "arzu-9380c",
  storageBucket: "arzu-9380c.firebasestorage.app",
  messagingSenderId: "772690795003",
  appId: "1:772690795003:web:ae9d9468933008ac78135e",
  measurementId: "G-JZ60Z96B8W"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app); // Inicializa el servicio de autenticación

export { app, analytics, db, auth }; // Añade auth a las exportaciones